import Vue from 'vue';
import Form from '@@/model/Form';
import Controls from '@@/components/Controls.vue';

new Vue({
  el: '#app-contact',
  components: {
    Controls
  },
  
  data() {
    return {
      form: null,
      fields1: {
        name : {
          name: "name",
          type: "text",
          label: "Full name",
          value: ''
        },
        email: {
          name: "email",
          type: "email",
          label: "Email Address",
          value: ''
        }
      },
      fields: {
        "name" : {
          "name" : "name",
          "type": "text",
          "label": "Full name",
          "value": null,
          "error": null,
          "info": "Last name, First name",
          "required": true,
          "constraints": {
            length: {
              minimum: 3,
              message: "must be at least 3 characters"
            }
          }
        },
        "email" : {
          "name" : "email",
          "type" : "email",
          "label" : "Email Address",
          "error": null,
          "value": null,
          "required" : true,
          "constraints": {
            "email": true
          }
        },
        "phone" : {
          "name": "phone",
          "type": "text",
          "label": "Phone number",
          "value": null,
          "error": null,
          "required": false
        },
        "subject": {
          "name" : "subject",
          "type" : "select",
          "label" : "Subject",
          "value" : "sales",
          "required" : true,
          "error": null,
          "data" : {
            "sales": "Product/Sales/Shipping Inquiry",
            "order": "Order Inquiry",
            "info" : "General Inquiry",
            "comments" : "Comments and Suggestion",
            "tech" : "Technical Inquiry"
          }
        },
        "message": {
          "name" : "message",
          "type" : "textarea",
          "label": "Message",
          "value": null,
          "required": true,
          "error": null,
          "style" : {
            "height" : '150px'
          },
          "constraints": {
            length: {
              minimum: 10,
              message: "must be at least 10 characters"
            }
          }
        },
        /*"captcha" : {
          "name" : "captcha",
          "type": "custom",
          "label": "Verify code",
          "value" : null,
          "required" : true,
          "error" : null,
          "info": "Type the code you see",
        } */
      }
    }
  },
  
  computed: {
  },
  
  created() {
    this.form = new Form('contact', this.fields1);
    this.$app.on('set', (key, val, old) => {
      console.log('something changed', key, val, old);
    });
    console.log('Vue created with store:', this.$app);
  },
  
  mounted() {
    this.form.setValues(this.$app.get('values'));
    this.form.setErrors(this.$app.get('errors'));
  },
  
  methods: {
    onSubmit(event) {
      try {
        console.log('form submitted.', this.form.getValues());
        let errors = this.form.validate();
        console.log('errors', errors);
        
        if(!errors) {
          console.log('no errors, returning to the browser...');
          this.form.clearErrors();
          this.form.reset();
          return true;
        }
      } catch(e) {
        console.log('exception', e);
      }
      
      
      event.preventDefault();
    }
  }
});